const creditCardManagement = {
  removeCard: 'הסר',
};

export default creditCardManagement;
